export function buildStandardFilters(uiProfile) {
    const filters = {
        SKU: { type: "text", width: "20%" },
        description: { type: "text", width: "20%" },
        DELN: { type: "text", width: "20%" },
        SORD: { type: "text", width: "20%" },
        ...(uiProfile.showDealerColumn && {
            dealerCode: {
                type: "text",
                width: "20%"
            }
        }),
        SCNU: { type: "text", width: "20%" },
        SCNA: { type: "text", width: "20%" },
        CNUM: { type: "text", width: "20%" },
        serialCode: { type: "text", width: "20%" },
        QuantityFilter: {
            type: "inputGroup",
            width: "25%",
            options: [
                { text: "...", value: "" },
                { text: "=", value: "=" },
                { text: ">", value: ">" },
                { text: "<", value: "<" }
            ]
        },
    };

    filters.filterButton = { type: "button" };
    filters.clearButton = { type: "clearButton" };

    return filters;
}

export const standardAdvancedFilterNames = [
    "DELN",
    "SORD",
    "dealerCode",
    "SCNU",
    "SCNA",
    "CNUM",
    "serialCode"
];